import axios from "axios";
import { processAxiosError } from "../processAxiosError";
import { SettingReadDto, SettingUpdateDto } from "../settings/interface";
import { INewsReturn, NewsItem } from "./loadNews";

/**
 * Saves news to the back end.
 *
 * @param backEndUrl - The backend API base URL for making HTTP requests
 * @param news - The news item object to save
 * @param controller - Optional AbortController for cancelling the request
 * @returns Promise<INewsReturn>
 */
export const saveNews = async (
  backEndUrl: string,
  news: NewsItem[],
  controller: AbortController,
): Promise<INewsReturn> => {
  // Send data
  try {
    const data: SettingUpdateDto = { value: JSON.stringify(news) };
    const response: { data: SettingReadDto } = await axios.put(`${backEndUrl}Settings/News`, data, {
      signal: controller.signal,
    });
    // Return successful result
    return { success: true, data: JSON.parse(response.data.value) as NewsItem[] };
  } catch (error: unknown) {
    console.warn(error);
    return processAxiosError("Save failed", error);
  }
};
